import "./queueFleet.css";
import "./client/client.css";
import { mountClientDetail } from "./client/page";

// Client Detail entry point. The page itself lives in ./client/: model.ts (validation of every reply), outcomes.ts
// (what publish/approve/generate results mean), one module per section, and page.ts (loading, state and actions).
// Kept here so the router and every old import keep working unchanged.
export async function clientDetailView(root: HTMLElement, params: Record<string, string>): Promise<void> {
  mountClientDetail(root, params);
}
